import { Injectable, ErrorHandler} from '@angular/core'
import * as Sentry from '@sentry/browser'
// @ts-ignore
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  constructor() {
    if (environment.production === true) {
      // @ts-ignore
      Sentry.init({
        dsn: 'https://197822dc5e984f06bcb6d4a51ddd6fce@o417174.ingest.sentry.io/5315791',
        release: 'angular-vop@' + environment.release
      });
    }
  }

  extractError(error) {
    if (error && error.ngOriginalError) {
      error = error.ngOriginalError;
    }
    if (typeof error === "string" || error instanceof Error) {
      return error;
    }
    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof Error) {
        return error.error;
      }
      if (error.error instanceof ErrorEvent) {
        return error.error.message;
      }
      if (typeof error.error === "string") {
        return `Server returned code ${error.status} with body "${error.error}"`;
      }
      return error.message;
    }
    return null;
  }

  handleError(error) {
    const extractedError = this.extractError(error) || "Handled unknown error";
    // @ts-ignore
    const eventId = Sentry.captureException(extractedError);
    
    if (!environment.production) {
      console.error(extractedError);
    }
    // Sentry.showReportDialog({ eventId });
  }
}